"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomColorPalette = void 0;
class CustomColorPalette {
    constructor() {
    }
    static getAttributeTypeMap() {
        return CustomColorPalette.attributeTypeMap;
    }
}
exports.CustomColorPalette = CustomColorPalette;
CustomColorPalette.discriminator = undefined;
CustomColorPalette.attributeTypeMap = [
    {
        "name": "backgroundHover",
        "baseName": "backgroundHover",
        "type": "string",
        "format": ""
    },
    {
        "name": "backgroundPrimary",
        "baseName": "backgroundPrimary",
        "type": "string",
        "format": ""
    },
    {
        "name": "backgroundSecondary",
        "baseName": "backgroundSecondary",
        "type": "string",
        "format": ""
    },
    {
        "name": "buttonPrimary",
        "baseName": "buttonPrimary",
        "type": "string",
        "format": ""
    },
    {
        "name": "interactiveAccent",
        "baseName": "interactiveAccent",
        "type": "string",
        "format": ""
    },
    {
        "name": "navigationAccent",
        "baseName": "navigationAccent",
        "type": "string",
        "format": ""
    },
    {
        "name": "primary",
        "baseName": "primary",
        "type": "string",
        "format": ""
    },
    {
        "name": "textDanger",
        "baseName": "textDanger",
        "type": "string",
        "format": ""
    },
    {
        "name": "textPrimary",
        "baseName": "textPrimary",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=CustomColorPalette.js.map